import { Component, ViewChild, ElementRef } from '@angular/core';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { BaseGridInputComponent } from '../base-grid-input/base-grid-input.component';

@Component({
  selector: 'grid-checkbox',
  templateUrl: './grid-checkbox.component.html',
  styleUrls: ['./grid-checkbox.component.css'],
  standalone: false
})
export class GridCheckboxComponent extends BaseGridInputComponent {
  @ViewChild('inputField') inputField: ElementRef;
  public id: string;

  constructor() {
    super();
    this.id = Math.random().toString();
  }

  agInit(params: any): void {
    this.params = params;
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams): void {}
}
